
module.exports = {
    promises: ['$qProvider', 'DEBUG_MODE', function($qProvider, DEBUG_MODE) {
        $qProvider.errorOnUnhandledRejections(DEBUG_MODE);
    }],
    analytics: ['$provide', function($provide) {
        $provide.decorator('$exceptionHandler', ['$log', '$delegate', '$injector',
            function($log, $delegate, $injector) {
                /**
                 * Transforms the exception into a useful string
                 * @method simpleStack
                 * @param  {Error} exception
                 * @return {String}
                 */
                function simpleStack(exception) {
                    if (!exception || !exception.stack) {
                        return false;
                    }
                    var stack = exception.stack.split("\n    at ");
                    return stack.slice(0, 4).join(' @ ')
                }

                return function(exception, cause) {
                    var msg = simpleStack(exception);
                    if (msg) {
                        $injector.get('Analytics').trackException(msg, true);
                    }
                    $delegate(exception, cause);
                };
            }
        ]);
    }],
};